export function resolveSelectedDepartment<T extends string>(
  selected: T,
  allowed: readonly string[] | null | undefined,
  fallback: T
): T {
  if (!allowed || allowed.length === 0 || allowed.includes(selected)) {
    return selected;
  }

  return fallback;
}
